import { useEffect, useRef } from 'react'
import { AppEvents, globalEventEmitter } from '~/utils/shared'
import CampaignChatMessage from './CampaignChatMessage'

export interface CampaignChatProps {
  messages: Message[]
  inlineChat?: boolean
}

function CampaignChat({ messages, inlineChat }: CampaignChatProps) {
  const endOfMessagesRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onScrollMessagesToBottom = () => {
      const animationDelay = 400
      setTimeout(() => {
        endOfMessagesRef.current?.scrollIntoView({ behavior: 'smooth' })
      }, animationDelay)
    }
    globalEventEmitter.on(AppEvents.ScrollMessagesToBottom, onScrollMessagesToBottom)
    return () => {
      globalEventEmitter.off(AppEvents.ScrollMessagesToBottom, onScrollMessagesToBottom)
    }
  }, [])

  return (
    <div className='flex flex-col gap-3'>
      {messages.map((message, index) => (
        <CampaignChatMessage key={index} message={message} inlineChat={inlineChat} />
      ))}
      <div ref={endOfMessagesRef} />
    </div>
  )
}

export default CampaignChat
